export const AuthActionsTypes = {
  UPDATE_JWT_TOKEN: 'UPDATE_JWT_TOKEN',
  UPDATE_JWT_TOKEN_FINISH: 'UPDATE_JWT_TOKEN_FINISH',
  SET_JWT_REFRESH_ERROR: 'SET_JWT_REFRESH_ERROR',
  SEND_PHONE_TOKEN: 'SEND_PHONE_TOKEN',
  SEND_PHONE_TOKEN_SUCCESS: 'SEND_PHONE_TOKEN_SUCCESS',
  SEND_PHONE_TOKEN_FAILURE: 'SEND_PHONE_TOKEN_FAILURE',
};
